import { reactive } from "vue"

export const store = reactive({
    isOpenLoginModal: false,
    isLogin: false,
    userName: ''
})